import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import { IonSkeletonText } from "@ionic/vue";
import { computed } from "vue";

import { SkeletonBaseProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'SkeletonBase',
  props: {
    show: { type: Boolean },
    variants: {},
    class: {}
  },
  setup(__props: any) {

const props = __props

const skeletonClass = computed<string>(() => {
    let className = 'skeleton-'

    if (!props.variants) return 'skeleton-purple-light-background ' + (props.class ?? '')

    if (!props.variants.light) className += 'purple-'
    else className += `${props.variants.light}-`

    if (!props.variants.dark) className += 'light-background '
    else className += `${props.variants.dark}-background `

    return className + (props.class ?? '')
})

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createBlock(_unref(IonSkeletonText), {
        key: 0,
        animated: "",
        class: _normalizeClass([skeletonClass.value, "m-0"])
      }, null, 8, ["class"]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})